<app-kontable
  #table
  id="reservation_gift_status"
  title="{{ 'loyalty.reservationGiftStatus' | translate }}"
  [columns]="[
    'id',
    {field: 'status_initial', title: 'loyalty.reservationGiftStatus_statusInitial', filterType: customFilter, filterTemplate: statusFilter},
    {field: 'status_final', title: 'loyalty.reservationGiftStatus_statusFinal', filterType: customFilter, filterTemplate: statusFilter},
    'action'
  ]"
  [titles]="['ID', 'loyalty.reservationGiftStatus_action']"
  [source]="giftStatus"
  [showInfoButton]="true"
  [showRecoverButton]="true"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showGlobalFilter]="false"
  (onAdd)="showDialog($event)"
  (onEdit)="showDialog($event)"
  (onRemove)="delete($event)"
  (onRecover)="recoverGiftStatus($event)"
>
  <!-- Filtro Stati -->
  <ng-template #statusFilter data-testid="statusFilter" let-col>
    <p-dropdown [options]="statusList" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
  </ng-template>
</app-kontable>

<p-dialog
        *ngIf="srvGiftStatus.giftStatusEdit"
        [(visible)]="srvGiftStatus.giftStatusEdit"
        [modal]="true"
        header="{{modalTitle}}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
    <app-loyalty-reservation-gift-status-form
            (giftStatusAdded)="giftStatusAdd($event)"
            (giftStatusUpdated)="giftStatusUpdate($event)"
            [dialogBoxGiftStatus]="srvGiftStatus.giftStatusEdit"
    ></app-loyalty-reservation-gift-status-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-gift-status/loyalty-reservation-gift-status.component.html